import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { MessageSeverity } from "primereact/api";
import { Message } from "primereact/message";

import { translationKeys } from "../../../../models/app-translation-keys";
import { IFileUploadErrors } from "../../../../models/interfaces/file-upload-errors.interface";

import "./FileUploadErrors.scss";

interface IFileUploadErrorsProps {
  errors: IFileUploadErrors;
}

export const FileUploadErrorsComponent: FunctionComponent<IFileUploadErrorsProps> = (props: IFileUploadErrorsProps) => {
  const { t } = useTranslation();

  const errorMessage = (errorMessage: string, severity: MessageSeverity | undefined) => {
    return <Message severity={severity} text={errorMessage} />;
  };

  return (
    <section className="file-upload-errors">
      {props.errors.hasReachMaximalFiles &&
        errorMessage(t(translationKeys.upload.error.hasReachMaximalFiles), MessageSeverity.WARN)}
    </section>
  );
};
